import { styled } from "@mui/material/styles";
import { Typography as MuiTypography } from "@mui/material";

export const ShowDetailsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flex: 1,
}));

export const MaxWidthContainer = styled("div")(({ theme }) => ({
  maxWidth: "620px",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  gap: theme.space._500,
}));

export const ShowActionsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.space._400,
}));

export const PriorityTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["4xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors["yellow.300"],
}));

export const TitleTypography = styled(MuiTypography)(({ theme }) => ({
  minHeight: "10rem",
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes["8xl"],
  fontWeight: theme.fontWeights.bold,
  lineHeight: theme.lineHeights.slim,

  color: theme.colors.white,

  "@media (max-width: 600px)": {
    minHeight: 0,
    fontSize: theme.fontSizes["6xl"],
  },
}));


export const SynopsisTypography = styled(MuiTypography)(({ theme }) => ({
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.lg,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.tall,
  whiteSpace: "pre-wrap",

  color: theme.colors["neutral.500"],
})) as typeof MuiTypography;
